//const API_KEY = process.env.REACT_APP_VF_API_KEY;

const buildVFHeaders = (api_key) => ({
  'Authorization': api_key,
  'accept': 'application/json',
  'content-type': 'application/json',
  'versionID': process.env.REACT_APP_VF_TEST_MODE === 'true' ? 'development' : 'production',
});

const vfInteract = async (user, userAction, api_key) => {
  const interractionUrl = `https://general-runtime.voiceflow.com/state/user/${user}/interact`;

  const payload = {
    action: userAction,
  };

  const data = await fetch(interractionUrl, {
    headers: buildVFHeaders(api_key),
    method: 'POST',
    body: JSON.stringify(payload),
  });

  const postRes = await data.json();
  // let audio = new Audio(postRes[0].payload.audio.src)
  // audio.play()
  return postRes;
};

const vfUpdateVariables = async (user, variables, api_key) => {
  const updateVariablesUrl = `https://general-runtime.voiceflow.com/state/user/${user}/variables`;

  const data = await fetch(updateVariablesUrl, {
    headers: buildVFHeaders(api_key),
    method: 'PATCH',
    body: JSON.stringify(variables),
  });

  if (!data.ok) {
    console.error('Failed to update variables', data);
  }

  const postRes = await data.json();
  return postRes;
};

const vfSendEvent = async (user, event_name, api_key) => {
  const sendEventUrl = `https://general-runtime.voiceflow.com/state/user/${user}/interact`;

  const payload = {
    action: {
      "type": "event",
      "payload": {
        "event": {
          "name": event_name
        }
      }
    },
  };

  const data = await fetch(sendEventUrl, {
    headers: buildVFHeaders(api_key),
    method: 'POST',
    body: JSON.stringify(payload),
  });

  const postRes = await data.json();
  return postRes;
};

const vfFetchState = async (user, api_key) => {
  const fetchVariablesUrl = `https://general-runtime.voiceflow.com/state/user/${user}`;

  const data = await fetch(fetchVariablesUrl, {
    headers: buildVFHeaders(api_key),
    method: 'GET'
  });

  if (!data.ok) {
    console.error('Failed to fetch state', data);
  }

  const postRes = await data.json();
  return postRes;
};

export {vfInteract, vfUpdateVariables, vfFetchState, vfSendEvent};
